/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".max[_ngcontent-%COMP%], .min[_ngcontent-%COMP%]{font-size:12px;padding-left:0}.max[_ngcontent-%COMP%]{text-align:right;padding-right:6px}.errors[_ngcontent-%COMP%], .override-message[_ngcontent-%COMP%]{text-align:center}.form-group-pst-question[_ngcontent-%COMP%]{display:flex;justify-content:center}"];
export { styles as styles };
